import React, { useState, useEffect } from "react";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Form } from "react-bootstrap";

const EmailReqStatus = () => {
    const [currentStatusDisplay, setCurrentStatusDisplay] = useState("Loading...");
    const [desiredStatus, setDesiredStatus] = useState(true); // true for 'yes', false for 'no'
    const [isLoading, setIsLoading] = useState(false);

    const fetchEmailRequiredStatus = async () => {
        setIsLoading(true);
        try {
            const { data, error } = await apiCall("GET", "/get-advance-info"); // Assuming this endpoint provides company info
            if (data) {
                // Assuming the API returns a field like 'email_required_status'
                console.log("00000000000", data.data)
                const fetchedStatus = data.data.Registration.is_email_verification_required.value;
                // Check if the fetched status is 'yes' or 1 to set as active
                const isActive = fetchedStatus === "yes" || fetchedStatus === 1;
                setCurrentStatusDisplay(isActive ? "Active" : "Inactive");
                setDesiredStatus(isActive);
            } else if (error) {
                toast.error(error.message || "Failed to fetch email required status.");
                setCurrentStatusDisplay("Error");
            }
        } catch (e) {
            console.error("Error fetching email required status:", e);
            toast.error("Failed to fetch email required status.");
            setCurrentStatusDisplay("Error");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEmailRequiredStatus();
    }, []);

    const handleUpdateStatus = async () => {
        setIsLoading(true);
        try {
            // Send "yes" if desiredStatus is true, "no" if false
            const statusToSend = desiredStatus ? "yes" : "no";
            const body = {
                // Assuming the API expects 'email_required_status' as the key for updating
                value: statusToSend,
            };
            console.log("Updating email required status with body:", body);

            // Assuming a specific endpoint for updating email required status
            const { data, error } = await apiCall("POST", `/update-email_verification`, body);

            if (error) {
                toast.error(error.message || "An error occurred while updating status.");
            } else {
                toast.success(data.message || "Email Required status updated successfully!");
                fetchEmailRequiredStatus(); // Re-fetch to display the updated status
            }
        } catch (error) {
            console.error("Error during status update:", error);
            toast.error(error.message || "An error occurred during update.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Container className="mt-4">
                <section id="email-required-status-section">
                    <div className="d-flex justify-content-center">
                        <h2>Email Verification Required Status</h2>
                    </div>
                    <section id="formContent">
                        <div className="form">
                            <Row>
                                <Col lg={6} style={{ margin: "auto" }}>
                                    <form onSubmit={(e) => { e.preventDefault(); handleUpdateStatus(); }}>
                                        <div id="formFields">
                                            <div className="mb-3">
                                                <label>Current Status:</label>
                                                <Form.Control
                                                    type="text"
                                                    value={currentStatusDisplay}
                                                    readOnly
                                                    disabled
                                                    className="form-control-plaintext"
                                                />
                                            </div>

                                            {/* Toggle for Desired Status */}
                                            <div className="mb-3" style={{ marginTop: '20px' }}>
                                                <label>Set New Status:</label>
                                                <Form.Check
                                                    type="switch"
                                                    id="email-required-status-switch"
                                                    label={desiredStatus ? "Active" : "Inactive"}
                                                    checked={desiredStatus}
                                                    onChange={(e) => setDesiredStatus(e.target.checked)}
                                                />
                                            </div>

                                            <Button
                                                type="submit"
                                                variant="primary"
                                                disabled={isLoading}
                                            >
                                                Update Status
                                            </Button>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </div>
                    </section>
                </section>
            </Container>
        </React.Fragment>
    );
};

export default EmailReqStatus;